<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'

  export default {
    name: 'station-bug',
    mixins: [templateMixin]
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/sstv-bug.vue